export const COMPANY_NAME = "Haus Of Vellichor LLC";
export const COMPANY_SHORT = "Haus of Vellichor";
export const COMPANY_INITIALS = "HV";
export const COMPANY_ADDRESS_FULL = "30777 Rancho California Rd, Suite 893501, Temecula, CA 92591";
export const COMPANY_LOCATION = "Temecula, California";
export const COMPANY_REGION = "Temecula, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=30777%20Rancho%20California%20Rd%2C%20Suite%20893501%2C%20Temecula%2C%20CA%2092591";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Meaningful things, thoughtfully kept" },
  { "label": "Format", "value": "Private collection, local-first" },
  { "label": "Location", "value": "Temecula, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Haus Of Vellichor LLC" },
  { "label": "Profile", "value": "A home for personal curiosities" },
  { "label": "Location", "value": "Temecula, California" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Objects with a story", "body": "Make room for the small objects, pages, and keepsakes that deserve to be remembered." },
  { "icon": "✦", "title": "A slower record", "body": "Keep the detail that matters: where something came from, why it stayed, and what it evokes." },
  { "icon": "✿", "title": "Private by design", "body": "The future collection experience is conceived to live on your device, without an account or cloud dependency." },
  { "icon": "❍", "title": "A cabinet, not a feed", "body": "Revisit a personal archive at your own pace, organized by curiosity rather than by noise." },
];
